import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface RootInterface {
    menuToggle: boolean;
    authToken?: string;
}

const initialState: RootInterface = {
    menuToggle: false,
    authToken: undefined,
};

export const rootSlice = createSlice({
    name: "root",
    initialState,
    reducers: {
        setAuthToken: (state, action: PayloadAction<string | undefined>) => {
            state.authToken = action.payload;
        },
        menuToggle: (state) => {
            state.menuToggle = !state.menuToggle;
        },
    },
});

export const { setAuthToken, menuToggle } = rootSlice.actions;

export default rootSlice.reducer;
